import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InicioSesionComponent } from './components/inicio-sesion/inicio-sesion.component';
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../../../environments/environment';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RegistroUsuarioComponent } from './components/registro-usuario/registro-usuario.component';
import { AppRoutingModule } from 'src/app/core/app-routing.module';
import { CalendarModule } from 'primeng/calendar';
@NgModule({
  declarations: [InicioSesionComponent, RegistroUsuarioComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarModule
  ],
  exports: [
    InicioSesionComponent
  ]
})
export class LoginModule { }
